import { AgentConfiguration, Certificate, isPastDate } from '@big-red-group/storefront-common-checkout'
import { customerCertificatesResponse } from '@/helpers/FakeApiHelper'
import { JsendResponse } from '@big-red-group/storefront-common-checkout/dist/types'

export const findCustomerByEmail = async (agentConfiguration: AgentConfiguration, email: string) => {
  // TODO get the agent id
  const getCustomerFromEmail = await fetch(
    `${process.env.LOKI_BASE_URL}/atlas/customer/${agentConfiguration.catalogueType}/${agentConfiguration.partnerCode}/${email}`,
    {
      method: 'GET',
      headers: {
        'content-type': 'application/json',
        'x-partner-code': agentConfiguration.partnerCode,
        'x-catalogue-type': agentConfiguration.catalogueType,
        'Accept-Language': agentConfiguration.language,
      },
    }
  )

  if (!getCustomerFromEmail.ok) {
    return undefined
  }

  const customer = await getCustomerFromEmail.json()
  return customer
}

export const prepareCustomerPreferences = (
  sales_and_promotion: boolean,
  travel_guides_and_inspiration: boolean,
  reminders: boolean,
  blanket_initial_subscription?: boolean
) => {
  return {
    preferences: [
      {
        preference_type: 'email_opt_in',
        preference_desc: 'email_opt_in',
        subscriptions: [
          {
            key: 'blanket_initial_subscription',
            value: blanket_initial_subscription ?? (sales_and_promotion || reminders || travel_guides_and_inspiration),
          },
          {
            key: 'sales_and_promotion',
            value: sales_and_promotion,
          },
          {
            key: 'reminders',
            value: reminders,
          },
          {
            key: 'travel_guides_and_inspiration',
            value: travel_guides_and_inspiration,
          },
        ],
      },
    ],
  }
}

export const fetchCustomerCertificates = async (
  agentConfiguration: AgentConfiguration,
  uuid: string
): Promise<Certificate[]> => {
  const certificatesResponse = await fetch(`${process.env.LOKI_BASE_URL}/customers/${uuid}/certificates`, {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      'x-partner-code': agentConfiguration.partnerCode,
      'x-catalogue-type': agentConfiguration.catalogueType,
      'Accept-Language': agentConfiguration.language,
    },
  })

  if (!certificatesResponse.ok) {
    return []
  }

  const response: JsendResponse<{ certificates: Certificate[] }> = await certificatesResponse.json()
  return response.data.certificates
}

export const extractEvProductIdsFromCertificates = (certificates: Certificate[]): number[] => {
  return certificates
    .filter((certificate) => certificate.product?.id && !isPastDate(new Date(certificate.expiryDate)))
    .map((certificate) => certificate.product!.id)
}
